import React from 'react'
import ScheduleFilters from '../components/ScheduleFilters'
import {postJson, resolveRoute} from '../helpers/ajax'
import * as kb from '../kb'
import {renderFragment} from '../helpers/react-helpers'

export default function ({userId, showPaymentsColumn, showDriverColumn}: any) {
    renderFragment(<ScheduleFilters/>, '#schedule-filters-container')

    // getDashboardDataTableOptions(resolveRoute('api.dashboardBookings'), {userId}, {
    //     showPaymentsColumn,
    //     showDriverColumn,
    //     table: '#user-bookings-table',
    //     language: {
    //         emptyTable: "No assigned, dispatched, or accepted bookings for this user"
    //     },
    //     storageKey: 'user'
    // })

    import(/* webpackPreload: true */'../components/BookingsDataTable').then(({BookingsDataTable}) => {
        renderFragment(<BookingsDataTable ajaxSource={resolveRoute('api.dashboardBookings')} serverData={{userId,includeYear:true}} {...{  showPaymentsColumn, showDriverColumn}} storageKey="user" language={{emptyTable:"No assigned, dispatched, or accepted bookings for this user"}} />, '#user-bookings-table');
    })

  const emailPasswordResetBtn = document.getElementById('email-password-reset') as HTMLButtonElement|null
    emailPasswordResetBtn?.addEventListener('click', function (event: Event) {
      event.preventDefault()
      emailPasswordResetBtn.disabled = true
      postJson(resolveRoute('api.email_password_reset', {id: userId}))
        .then((res: any) => {
          if (res.ok) {
            kb.notify({
              html: 'Password reset email has been sent!',
              className: "success",
            })
          } else {
            kb.notify({
              html: "Server error. This service may be down or broken at moment; please bear with us while we get it working again!",
              className: "error",
            })
          }
        })
        .catch((err: any) => {
          kb.notify({
            html: "A network error occurred. Please try a few more times!",
            className: "error",
          })
        })
        .finally(() => {
          emailPasswordResetBtn.disabled = false
        })
    })
}
